import { useMutation } from '#react-query';
import { deleteChatroom } from '../../services';
import { useDeleteChatroomFromCache } from '../cache';

export const useDeleteChatroomMutation = () => {
  const deleteChatroomFromCache = useDeleteChatroomFromCache();

  return useMutation<unknown, Error, { chatroomId: string }>({
    async mutationFn({ chatroomId }) {
      await deleteChatroom({ routeParams: { id: chatroomId } });
    },
    async onSuccess(_data, { chatroomId }) {
      await deleteChatroomFromCache({ chatroomId });
    },
  });
};
